import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMouseScrollUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMouseScrollUp"><Path fillRule="evenodd" clipRule="evenodd" d="M8.79199 5.04008L12 2.90141L15.208 5.04008L16.0401 3.79201L12 1.09863L7.95994 3.79201L8.79199 5.04008Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M6 12C6 8.68631 8.68629 6.00002 12 6.00002C15.3137 6.00002 18 8.68631 18 12V17C18 20.3137 15.3137 23 12 23C8.68629 23 6 20.3137 6 17V12ZM12.75 10H11.25V14H12.75V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMouseScrollUp;
